module.exports = __webpack_public_path__ + "static/header-image-9ba30911f935b9a90023f0e98043b184.jpg";